import { useQuery } from '@tanstack/react-query'

import { propostaKeys } from '@/features/proposta/brasil/utils'
import { GetCorretagens } from '@/features/proposta/shared/http/get-corretagens.service'
import { TRINTA_MINUTOS } from '@/utils/constants'

export const useCorretagens = (simulacoesIds: string[]) => {
  return useQuery({
    queryKey: propostaKeys.listaCorretagens(simulacoesIds),
    queryFn: async () => new GetCorretagens().execute(simulacoesIds).then((res) => res.data),
    staleTime: TRINTA_MINUTOS,
  })
}
